import Id from './Id';
import CompletionDate from './CompletionDate';
import SourceStorage from './SourceStorage';
import CreatorUser from './CreatorUser';
import CompletingUser from './CompletingUser';
import Currency from './Currency';
import Supplier from './Supplier';
import ReferenceNumber from './ReferenceNumber';
import Status from './Status';
import Reason from './Reason';
import ReceiptNumber from './ReceiptNumber';
import Created from './Created';
import Updated from './Updated';
import Comment from './Comment';

export const labels = {
  Id: 'Id',
  ReceiptNumber: 'Bizonylatszám',
  Comment: 'Megjegyzés',
  CompletionDate: 'Teljesítés',
  SourceStorage: 'Raktár',
  CreatorUser: 'Rögzítette',
  CompletingUser: 'Teljesítette',
  Currency: 'Deviza',
  Supplier: 'Szállító',
  ReferenceNumber: 'Hivatkozási szám',
  Status: 'Státusz',
  Reason: 'Selejtezés okai',
  Created: 'Létrehozva',
  Updated: 'Módosítva',
};

export const allColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'ReceiptNumber',
  fixed: true,
}, {
  value: 'CompletionDate',
}, {
  value: 'Comment',
}, {
  value: 'SourceStorage',
}, {
  value: 'Reason',
}, {
  value: 'CreatorUser',
}, {
  value: 'CompletingUser',
}, {
  value: 'Currency'
}, {
  value: 'ReferenceNumber'
}, {
  value: 'Supplier'
}, {
  value: 'Updated',
}, {
  value: 'Status',
}, {
  value: 'Created',
}];

export const defaultColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'ReceiptNumber',
  fixed: true,
},  {
  value: 'Status',
},  {
  value: 'Reason',
},  {
  value: 'CompletionDate',
},  {
  value: 'SourceStorage',
}, {
  value: 'CreatorUser',
}, {
  value: 'CompletingUser',
}, {
  value: 'Currency'
}];

export const defaultSort = {
  prop: SourceStorage.propName,
  order: 'ascending'
};

export default {
  CompletionDate,
  SourceStorage,
  CreatorUser,
  CompletingUser,
  Currency,
  ReferenceNumber,
  Supplier,
  Updated,
  Created,
  Id,
  Status,
  Reason,
  ReceiptNumber,
  Comment,
};
